import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HipobuySpreadsheetGuide from "../pages/article/hipobuy-spreadsheet-guide/page";
import HipobuyVsKakobuyComparison from "../pages/article/hipobuy-vs-kakobuy-comparison/page";
import HipobuySafetyGuide from "../pages/article/hipobuy-safety-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/hipobuy-spreadsheet-guide",
    element: <HipobuySpreadsheetGuide />,
  },
  {
    path: "/article/hipobuy-vs-kakobuy-comparison",
    element: <HipobuyVsKakobuyComparison />,
  },
  {
    path: "/article/hipobuy-safety-guide",
    element: <HipobuySafetyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;